// С подсказкой на английском
import { getBrowserLocales } from "@/util/get-browser-locale";

let _annotated = {
    en: "English"
}
// ru: "Русский (Russian)"

// Краткая форма
let _simple = {
    en: "English"
}
// ru: "Русский"

function filter(input) {
    let filtered = [];
    const browserLocales = getBrowserLocales({ countryCodeOnly: true })
    for (const [key, value] of Object.entries(input)) {
        if (key == 'en' || browserLocales.find(i => i == key)) {
            filtered.push([key, value])
        }
    }

    return Object.fromEntries(filtered)
}

// Отфильтровать, если есть в браузере то показать
let annotated = filter(_annotated);
let simple = filter(_simple);

// Включить все
// let annotated = _annotated);
// let simple = _simple);


export {annotated, simple}